export class CarCard {
  EXCHANGE_RATE_USD = 3.5

  constructor(node) {
    this.el = node;
    this.name = null;
    this.deposit = {
      AED: null,
      USD: null,
    };
    this.prices = []
    
    this.name = this.el.querySelector('[data-name]')?.dataset?.name || ''
    this.deposit.AED = Number(this.el.querySelector('[data-deposit]')?.dataset?.deposit) ?? 0;
    // this.deposit.USD = Number(this.el.querySelector('[data-deposit-usd]')?.dataset?.depositUsd) ?? 0;
    this.deposit.USD = this.convertToUSD(this.deposit.AED)

    // const pricesNode = this.el.querySelectorAll('[data-days-min][data-days-max][data-price][data-price-usd]')
    const pricesNode = this.el.querySelectorAll('[data-days-min][data-days-max][data-price]')

    pricesNode.forEach((element, index) => {
      const priceUnit = {}
      priceUnit.price = element.dataset.price
      // priceUnit.priceUSD = element.dataset.priceUsd
      priceUnit.priceUSD = this.convertToUSD(priceUnit.price)
      priceUnit.daysRange = {
        max: Number(element.dataset.daysMax),
        min: Number(element.dataset.daysMin)
      }
      this.prices.push(priceUnit)
    });
  }

  convertToUSD(number) {
    return Math.ceil(number / this.EXCHANGE_RATE_USD)
  }

  getPriceUnit(days) {
    return this.prices.find(priceUnit => days >= priceUnit.daysRange.min && days <= priceUnit.daysRange.max)
  }

  getPricePerDay(days) {
    if (!days) days = 1
    const priceUnit = this.getPriceUnit(days)
    return { AED: priceUnit.price, USD: priceUnit.priceUSD }
  }

  getTotalPrice(days) {
    if (!days) days = 1
    const priceUnit = this.getPriceUnit(days)

    return {
      AED: priceUnit.price * days + this.deposit.AED,
      USD: priceUnit.priceUSD * days + this.deposit.USD,
    }
  }
}

// const cardNode = document.querySelector('[data-id-car]')
// const car = new CarCard(cardNode)

// console.log(car)
// console.log(car.getTotalPrice(5))